<!--Loading Spinner-->
<div *ngIf="isProcessing">
  <app-spinner></app-spinner>
</div>
 <!-- Content Header (Page header) -->
 <section class="content-header">
    <div class="content-header">
       <div class="container-fluid">
         <div class="row mb-2">
           <div class="col-sm-6">
               <h3>Unpaid Duties</h3>
           </div>
           <div class="col-sm-6">
             <ol class="breadcrumb float-sm-right">
               <li class="breadcrumb-item"><a routerLink="/"><i class="nav-icon fas fa-tachometer-alt"></i>&nbsp;Dashboard</a></li>
               <li class="breadcrumb-item active">Unpaid Duties</li>
             </ol>
           </div><!-- /.col -->
         </div><!-- /.row -->
       </div><!-- /.container-fluid -->
   </div>
   <h5>Filters</h5>
   <hr>
  <div class="row">
    <div class="col-md-8">
        <div class="row">
          <div class="col">
            <div class="col-md-4">
              <form class="form-inline">
                <div class="form-group">
                    <label>Consignee:</label>&nbsp;
                    <select name="consignee_id"  class="form-control" (change)="onConsigneeSelectChange($event.target)">
                        <option value="">All</option>
                        <option [value]="consignee.id" *ngFor="let consignee of consignees">{{ consignee.consignee_name }}</option>
                    </select>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label>Agent:</label>&nbsp;
                    <select name="agents" class="form-control" (change)="onAgentSelectChange($event.target)">
                      <option value="">All</option>
                      <option [value]="agent.id" *ngFor="let agent of agents">{{ agent.company_name }}</option>
                    </select>
                </div>
              </form>
            </div>
          </div>
        </div>
    </div>
    <div class="col-md-4">
      <div class="row">
          <div class="col">
              <input type="text" class="form-control" placeholder="Search by Ref. Number, BL Number, Chassis Number or Doc Ref. Number" (input)="onSearchTextChange($event)">
          </div>
      </div>
    </div>
  </div>
    <hr>

  </section>
     <!-- /.content-header -->
   <section class="content">
   <div class="container-fluid">
      <h5>Payment</h5>
      <hr>
      <form [formGroup]="dutyPayment" (ngSubmit)="handleSubmit()">
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
              <label>Amount to pay:</label>
              <input type="text" class="form-control" placeholder="Amount Paid" [(ngModel)]="amountToPay" [ngModelOptions]="{standalone: true}" readonly>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
              <label>Payment Date:<span style="color:red;">*</span></label>
              <input type="date" formControlName="payment_date" class="form-control" placeholder="Payment Date" value="">

              <span *ngIf="submitted && dutyPayment.get('payment_date')?.hasError('required')" style="color:red"> <strong>Please enter or select payment date!</strong></span>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Bank:<span style="color:red;">*</span></label>
            <select formControlName="bank_account" class="form-control">
                <option value="">Select</option>
                <option [value]="bank_account.id" *ngFor="let bank_account of bank_accounts">{{ bank_account.bank_name }}</option>
            </select>

            <span *ngIf="submitted && dutyPayment.get('bank_account')?.hasError('required')" style="color:red"> <strong>Please select a bank account!</strong></span>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group" style="margin-top: 30px;">
            <button type="submit" class="btn btn-outline-success"><i class="fas fa-money-check" aria-hidden="true">&nbsp;</i>Pay Selected</button>
          </div>
        </div>
      </div>
      <div class="card">
          <div class="card-header">
            <h3 class="card-title">Select duties to pay</h3>
          </div>
          <!-- /.card-header -->
          <div class="card-body" style="overflow-x: auto;">
            <!--Error Message-->
            <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="errorMessage">
              <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
              {{errorMessage}}
            </div>
            <!--Warning Message-->
            <div class="alert alert-warning alert-dismissible" role="alert" *ngIf="warningMessage">
              <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
              {{warningMessage}}
            </div>
             <!--Success Message-->
             <div class="alert alert-success alert-dismissible" role="alert" *ngIf="successMessage">
              <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
              {{successMessage}}
            </div>
            <table id="example1" class="table table-bordered table-hover" style="white-space: nowrap; width: auto; min-width: 100%;">
                <thead>
                    <tr>
                        <th></th>
                        <th>Document Reference</th>
                        <th>Added On</th>
                        <th>BL No.</th>
                        <th>Make</th>
                        <th>Model</th>
                        <th>Chassis No.</th>
                        <th>Ref. Number</th>
                        <th>Duty Amount</th>
                        <th>Agent</th>
                        <th>Consignee</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let duty of unpaid_duties | searchDutyPayment: searchText | paginate: { itemsPerPage: 10, currentPage: page, totalItems: count }; let i = index">
                    <!-- Main row -->
                    <tr>
                      <td>
                        <input type="checkbox" [checked]="isSelected(duty)" (change)="checkboxChange($event, duty,duty.amount_paid)">
                      </td>
                      <td>
                        <ng-container *ngIf="duty.is_consolidated">
                          <button type="button" class="btn btn-sm btn-link" (click)="toggleExpanded(i,duty.bl_no)">
                            <i class="fas" [ngClass]="{'fa-plus': !expandedRows[i], 'fa-minus': expandedRows[i]}"></i>
                          </button>
                        </ng-container>
                        {{ duty.doc_ref_no }}
                      </td>
                      <td>{{ duty.added_on | date: 'dd-MM-yyyy' }}</td>
                      <td>{{ duty.bl_no }}</td>
                      <td>{{ duty.make }}</td>
                      <td>{{ duty.model }}</td>
                      <td>{{ duty.chassis_no }}</td>
                      <td>{{ duty.pmt_ref_no }}</td>
                      <td>{{ duty.amount_paid | currency:'Kshs ' }}</td>
                      <td>{{ duty.agent_name }}</td>
                      <td>{{ duty.consignee_name }}</td>
                      <td>
                        <button type="button" class="btn btn-success btn-sm"
                                (click)="viewEntryAndPaymentSlip(duty.entry_id, duty.txn_id)">
                          <i class="fas fa-paperclip" aria-hidden="true"></i>&nbsp;View Entry
                        </button>
                      </td>
                    </tr>

                    <!-- Collapsible row -->
                    <tr *ngIf="expandedRows[i]">
                      <td colspan="12">
                        <!-- Put the inner vehicle list here -->
                        <table class="table table-sm table-bordered mb-0">
                          <thead>
                            <tr>
                              <th>Make</th>
                              <th>Model</th>
                              <th>Chassis No</th>
                              <th>Engine No.</th>
                              <th>Engine CC</th>
                              <th>Fuel</th>
                              <th>Mileage</th>
                              <th>Colour</th>
                              <th>Yr of Mfg</th>
                              <th>Weight</th>
                              <th>CBM</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let vehicle of vehicles">
                              <td>{{ vehicle.make }}</td>
                              <td>{{ vehicle.model }}</td>
                              <td>{{ vehicle.chassis_no }}</td>
                              <td>{{ vehicle.engine_no }}</td>
                              <td>{{ vehicle.engine_cc }}</td>
                              <td>{{ vehicle.fuel }}</td>
                              <td>{{ vehicle.mileage }}</td>
                              <td>{{ vehicle.colour}}</td>
                              <td>{{ vehicle.year }}</td>
                              <td>{{ vehicle.weight }}</td>
                              <td>{{ vehicle.cbm}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
                <tfoot>
                    <tr>
                      <td colspan="8"><b>Total</b></td>
                      <td><b>{{unpaidDuty.total_unpaid_duty| currency:'Kshs '}}</b></td>
                    </tr>
                </tfoot>
            </table>
            <pagination-controls (pageChange)="pageChangeEvent($event)"></pagination-controls>
          </div>
          <!-- /.card-body -->
      </div>
    </form>
   </div>
   </section>
